export default {
  // 對話框標題
  title: "保存畫布",

  // 表單標籤
  canvasName: "畫布名稱",
  canvasDescription: "畫布描述",

  // 占位符
  namePlaceholder: "請輸入畫布名稱(必填)",
  descriptionPlaceholder: "請描述畫布",

  // 按鈕
  cancel: "取消",
  confirm: "確認",

  // 驗證規則
  nameRequired: "畫布名稱為必填項",
};
